<!-- <div style="margin: 16px; padding-bottom: 1px;">
    <div style="margin: auto;" [style.width]="authService.isLoggedIn()? '100%': '80%'">
        <div style="padding: 16px; width: 100%; background: #fff; font-size: 14px; font-weight: 500; border-radius: 8px;"
            class="card-item app-shadow">
            <div *ngIf="!vendor || (!isValidProvider)">
                <nz-alert nzType="warning" nzMessage="Warning" nzDescription={{getMessage()}} nzShowIcon></nz-alert>

            </div>
            <div *ngIf="vendor && isValidProvider">
                <div class="text-center font-18 font-weight-700" style="margin-bottom: 15px;">
                    {{vendor}} Api Doc
                </div>
                <div>
                    <div class="font-weight-600 font-16">
                        Get product list api
                    </div>
                    <span class="font-weight-600">
                        Method:
                    </span>
                    <span style="font-style: italic;">GET</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="productsApi"></app-copy-to-clipboard>


                </div>
                <div class="font-italic">
                    Success Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
            <code>
                <span>
                    {{successRes}}
                </span>
            </code>
        </pre>
                </div>
                <div class="font-italic">
                    Server error response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
            <code>
                <span>
                    {{wrongServiceRes}}
                </span>
            </code>
        </pre>
                </div>
                <div>
                    <div class="font-weight-600 font-16">
                        OTP Send api(Initiate charging)
                    </div>
                    <span class="font-weight-600">
                        Method:
                    </span>
                    <span style="font-style: italic;">POST</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="createCheckoutSessionApi"></app-copy-to-clipboard>

                    <nz-alert nzType="warning"
                        nzMessage="Query params are not allowed in PaymentSuccessRedirectUrl & PaymentFailedRedirectUrl"
                        nzShowIcon style="margin: 8px;"></nz-alert>




                </div>
                <div class="font-italic">
                    Reqeust body:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
            <code>
                <span>
                    {{reqBody}}
                </span>
            </code>
        </pre>
                </div>
                <div class="font-italic">
                    Success Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
            <code>
                <span>
                    {{reqSucRes}}
                </span>
            </code>
        </pre>
                </div>
                <div class="font-italic">
                    Server error response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
            <code>
                <span>
                    {{reqServerErrorRes}}
                </span>
            </code>
        </pre>
                </div>
                <div>
                    <div class="font-weight-600 font-16">
                        OTP verify api(charging)
                    </div>
                    <span class="font-weight-600">
                        Method:
                    </span>
                    <span style="font-style: italic;">POST</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="verifyCheckoutSessionApi"></app-copy-to-clipboard>
                </div>


                <div class="font-italic">
                    Reqeust body:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
          <code>
              <span>
                  {{otpVerifyReqBody}}
              </span>
          </code>
      </pre>
                </div>
                <div class="font-italic">
                    Success Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
            <code>
                <span>
                    {{optVerifySucRes}}
                </span>
            </code>
        </pre>
                </div>
                <div class="font-italic">
                    Server error response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
          <code>
              <span>
                  {{optVerifyServerError}}
              </span>
          </code>
      </pre>
                </div>

                <div>
                    <div class="font-weight-600 font-16">
                        Subscription check api
                    </div>
                    <span class="font-weight-600">
                        Method:
                    </span>
                    <span style="font-style: italic;">GET</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="checkSubscriptionApi"></app-copy-to-clipboard>
                    <app-copy-to-clipboard [title]="'URL'" [api]="checkSubscriptionApiWithTrue"></app-copy-to-clipboard>
                </div>

                <div class="code-block-container">
                    <div class="font-italic">
                        Success Response:
                    </div>
                    <pre class="code-block">
                    <code>
                        <span>
                            {{checkReqRes}}
                        </span>
                    </code>
                    </pre>
                </div>

                <div class="code-block-container">
                    <div class="font-italic">
                        Not found subscription Response:
                    </div>
                    <pre class="code-block">
            <code>
                <span>
                    {{checkNotFoundRes}}
                </span>
            </code>
        </pre>
                </div>
                <div>
                    <div class="font-weight-600 font-16">
                        Subscription cancel api
                    </div>
                    <span class="font-weight-600">
                        Method:
                    </span>
                    <span style="font-style: italic;">POST</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="cancelSubscriptionApi"></app-copy-to-clipboard>
                    <div>
                        <span class="font-weight-600">
                            Api key(need to pass in header):
                        </span>
                        <span style="font-style: italic;">x-api-key</span>
                    </div>
                    <div>
                        <span class="font-weight-600">
                            Value:
                        </span>
                        <span style="font-style: italic;">check it in
                            <span class="app-link">cancelApiEncryptionDoc</span>
                        </span>
                    </div>
                </div>
                <div>
                    <div class="font-italic">
                        Reqeust body:
                    </div>
                    <div class="code-block-container">
                        <pre class="code-block">
                <code>
                    <span>
"8m9XxNZx0MdaJmTvOyzKD8WWZmvd6t0/cquRBUIOdGXRIv0lbJKOC3AFeRZ/w+0ZZ6TCcFxAd4hFOKVaG/ri3w=="
                    </span>
                </code>
            </pre>
                    </div>
                    <div class="font-16">
                        Note:
                    </div> Here Request body is a encrypted string. See more about encryption in
                    <span class="app-link">cancelApiEncryptionDoc</span>
                </div>
                <div class="font-italic">
                    Success Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
            <code>
                <span>
                    {{cancelReq}}
                </span>
            </code>
        </pre>
                </div>
                <div class="font-italic">
                    Failed Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
            <code>
                <span>
                    {{cancelRes}}
                </span>
            </code>
        </pre>
                </div>
            </div>
        </div>
    </div>
</div> -->









<div style="margin: 16px; padding-bottom: 1px;">
    <div style="margin: auto;" [style.width]="authService.isLoggedIn()? '100%': '80%'">
        <div style="padding: 16px; width: 100%; background: #fff; font-size: 14px; font-weight: 500; border-radius: 8px;"
            class="card-item app-shadow">
            <div *ngIf="!vendor">

                <nz-alert nzType="warning" nzMessage="Warning"
                    nzDescription="Not found any docs for you please contact with administrator." nzShowIcon></nz-alert>
            </div>
            <div *ngIf="vendor">
                <div class="text-center font-18 font-weight-700" style="margin-bottom: 15px;">
                    {{vendor}} Api Doc
                </div>

                <!-- Get product list api : Start -->
                <div>
                    <h1>Get product list api :</h1>
                    <p>
                        The products endpoint allows clients to retrieve a list of available products for billing
                        purposes. This endpoint provides details about different subscription options, such as
                        their names, prices, and whether the user is already subscribed to them.
                    </p>
                    <b>Method:</b>
                    <span style="font-style: italic;">GET</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="productsApi"></app-copy-to-clipboard>

                    <div style="margin-top: 20px;">
                        <b>Response Structure:</b>
                        The API response is a JSON array containing objects, each representing a product. Each
                        product object includes the following fields:

                        <ul>
                            <li><span class="bold-text">serviceId: string -</span> Unique identifier for the product.
                            </li>
                            <li><span class="bold-text">title: string -</span> Name of the product or subscription
                                option.</li>
                            <li><span class="bold-text">validity: string -</span> Validity of the product.</li>
                            <li><span class="bold-text">price: string -</span> Unit price of the product in the
                                specified
                                currency.</li>
                        </ul>
                    </div>
                </div>
                <div class="font-italic">
                    Success Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{successRes}}
                    </span>
                </code>
            </pre>
                </div>
                <div class="font-italic">
                    Wrong service name response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{wrongServiceRes}}
                    </span>
                </code>
            </pre>
                </div>
                <!-- Get product list api : End -->

                <!-- Checkout api(Initiate charging) : Start -->
                <div>

                    <h1>Checkout api(Initiate charging)</h1>
                    <b>Method:</b>
                    <span style="font-style: italic;">POST</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="createCheckoutSessionApi"></app-copy-to-clipboard>


                    <b>Request Headers:</b>

                    <ul>
                        <li><span class="bold-text">deviceType:</span> Indicates the type of device initiating the
                            checkout.</li>
                        <li><span class="bold-text">Example Value:</span> mobile</li>
                    </ul>


                </div>

                <div style="margin-top: 20px;">
                    <b>Request Structure:</b>

                    <ul>
                        <li><span class="bold-text">MSISDN: string -</span> Phone number to initiate the payment
                            seassion.</li>
                        <li><span class="bold-text">ServiceId: string -</span> Unique identifier for the product.</li>
                        <li><span class="bold-text">PaymentSuccessRedirectUrl: string -</span> This field specifies the
                            URL where
                            the user should be redirected
                            upon successful completion of the payment process.</li>
                        <li><span class="bold-text">PaymentFailedRedirectUrl: string -</span> This field indicates the
                            URL where
                            the user should be redirected
                            if the payment process failure.</li>
                    </ul>
                </div>

                <b>Reqeust body:</b>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{reqBody}}
                    </span>
                </code>
            </pre>
                </div>
                <div class="font-italic">
                    Success Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{reqSucRes}}
                    </span>
                </code>
            </pre>
                </div>
                <div class="font-italic">
                    Server error response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{reqServerErrorRes}}
                    </span>
                </code>
            </pre>
                </div>

                <!-- Checkout api(Initiate charging) : End -->

                <!--  Subscription check api : Start -->
                <div>
                    <h1>
                        Subscription check api
                    </h1>
                    <p>The Subscription Check API allows users to verify the subscription status for a specific MSISDN
                        (Mobile Station
                        International Subscriber Directory Number) within this billing system. It provides
                        information on the
                        subscription status, service ID, and next renewal date if applicable.</p>

                    <span class="font-weight-600">
                        Method:
                    </span>
                    <span style="font-style: italic;">GET</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="checkSubscriptionApi"></app-copy-to-clipboard>

                    <div>
                        Parameters:
                        <ul>
                            <li><span class="bold-text">isShowAll: boolean -</span> A boolean parameter indicating
                                whether to show
                                all subscriptions associated
                                with the provided MSISDN. Set to false to
                                retrieve only the primary subscription information.</li>
                        </ul>
                    </div>

                    <div>
                        Success Structure:

                        <ol>
                            <li>Response when "isShowAll" is false:
                                <ul>
                                    <li><span class="bold-text">Status Code:</span> 200</li>
                                    <li><span class="bold-text">Message:</span> "Successful"</li>
                                    <li><span class="bold-text">Data:</span>
                                        <ul>
                                            <li><span class="bold-text">msisdn:</span> The MSISDN for the primary
                                                subscription.</li>
                                            <li><span class="bold-text">serviceId:</span> The unique identifier for the
                                                subscribed service.</li>
                                            <li><span class="bold-text">nextRenewalDate:</span> The timestamp indicating
                                                the next renewal date of the
                                                subscription.</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>Response when "isShowAll" is true:
                                <ul>
                                    <li><span class="bold-text">Status Code:</span> 200</li>
                                    <li><span class="bold-text">Message:</span> "Successful"</li>
                                    <li><span class="bold-text">Data:</span> An array containing objects with
                                        subscription details for all associated
                                        subscriptions.
                                        <ul>
                                            <li><span class="bold-text">msisdn:</span> The MSISDN for each subscription.
                                            </li>
                                            <li><span class="bold-text">serviceId:</span> The unique identifier for each
                                                subscribed service.</li>
                                            <li><span class="bold-text">nextRenewalDate:</span> The timestamp indicating
                                                the next renewal date of each
                                                subscription</li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ol>
                    </div>
                </div>
                <div class="font-italic">
                    Success Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{checkReqRes}}
                    </span>
                </code>
            </pre>
                </div>
                <div class="font-italic">
                    Not found subscription Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{checkNotFoundRes}}
                    </span>
                </code>
            </pre>
                </div>
                <!--  Subscription check api : End -->
                <!--  Subscription cancel api : Start -->
                <div>
                    <h1>
                        Subscription cancel api
                    </h1>
                    <p>The Subscription Cancel API allows users to cancel a subscription within this billing
                        system. By submitting a
                        POST request to the specified endpoint with the appropriate API key in the header and an
                        encrypted request body
                        containing subscription details,users can initiate the cancellation process for a specific
                        subscription.</p>
                    <span class="font-weight-600">
                        Method:
                    </span>
                    <span style="font-style: italic;">POST</span>
                    <app-copy-to-clipboard [title]="'URL'" [api]="cancelSubscriptionApi"></app-copy-to-clipboard>
                    <div>
                        <span class="font-weight-600">
                            Api key(need to pass in header):
                        </span>
                        <span style="font-style: italic;">x-api-key</span>
                    </div>
                    <div>
                        <span class="font-weight-600">
                            Value:
                        </span>
                        <span style="font-style: italic;">check it in
                            <span class="app-link">cancelApiEncryptionDoc</span>
                        </span>
                    </div>
                </div>
                <div>
                    <div class="font-italic">
                        Reqeust body:
                    </div>
                    <div class="code-block-container">
                        <pre class="code-block">
                    <code>
                        <span>
    "8m9XxNZx0MdaJmTvOyzKD6WWZmvd6t0/cqueBUIOdGXRIv0lbJKOC3AFeRZ/w+0ZZ6TCcFxAd4hFOKVaG/ri3w=="
                        </span>
                    </code>
                </pre>
                    </div>
                    <div class="font-16">
                        Note:
                    </div> Here Request body is a encrypted string. See more about encryption in
                    <span class="app-link">cancelApiEncryptionDoc</span>
                </div>
                <div class="font-italic">
                    Success Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{cancelReq}}
                    </span>
                </code>
            </pre>
                </div>
                <div class="font-italic">
                    Failed Response:
                </div>
                <div class="code-block-container">
                    <pre class="code-block">
                <code>
                    <span>
                        {{cancelRes}}
                    </span>
                </code>
            </pre>
                </div>
                <!--  Subscription cancel api : End -->


                <!-- How to configure Notification : Start-->
                <div>
                    <h1>
                        Setup Notification
                    </h1>

                    <p>Set up the notification mechanism within the provider's system to send notifications to provider
                        after completing a payment
                        transaction. This involves configuring the HTTPS API endpoint to receive notifications and
                        defining the parameters
                        required for notification delivery.</p>

                    <span class="font-weight-600">
                        Method:
                    </span>
                    <span style="font-style: italic;">GET</span>

                    <p style="color: red;"><b>The notification API must be GET request.</b></p>
                    <h2>Notification Parameters</h2>
                    After completing a payment transaction,sending notifications through the HTTPS API:

                    <ul>
                        <li><span class="bold-text">Notification URL:</span> The URL where the HTTPS API endpoint is
                            hosted by the provider.</li>
                        <li><span class="bold-text">MSISDN: </span>The mobile number associated with the user's account,
                            which is charged or
                            undergoing an action
                            (e.g., activation,deactivation, charge renewal).</li>
                        <li><span class="bold-text">ServiceID:</span> Unique identifier for the service notifying the
                            user.</li>
                        <li><span class="bold-text">ActionType:</span> Type of action being notified (e.g. ACT, REN,
                            DACT).</li>
                        <ul>
                            <li>ACT : Activation</li>
                            <li>DACT : Deactivation</li>
                            <li>REN : Renewal</li>
                        </ul>
                        <li>ActionMessage: ActionType description or notification content. (e.g. deactivation, Charged)
                        </li>
                    </ul>

                    <h2>Sample Notification URL</h2>
                    <p>The HTTPS API notification URL format for sending notifications to users is as follows:</p>

                    <div class="code-block-container">
                        <pre class="code-block">
                                                <code>
                                                    <span
                                                        style="padding: 10px;">{{"https://www.example.com/notification?msisdn={msisdn}&ServiceID={serviceId}&ActionType={action}&ActionMessage={messageId}"}}</span>
                                                </code>
                                            </pre>
                    </div>

                </div>

                <!-- How to configure Notification : End-->
            </div>
        </div>
    </div>
</div>